@if (liquidation()?.status() == 'pending' || liquidation()?.status() == 'active') {
  <img
    class="product-card__promoLogo"
    src="{{ assetsImage + liquidation().images[size()] }}"
    alt="{{ liquidation.name }} Logo" />
}
